// Helpers and constants for the "Analyse web-site" page.
// Extracted from AnalyzeWebsitePage.js to keep that component focused on
// rendering and state wiring.

// Auction / liquidation sites the website scanner is allowed to analyze.
// Keep in sync with `core/allowed_auction_sites.py` and
// `chrome-extension/background.js`.
export const ALLOWED_AUCTION_DOMAINS = [
  'liquidation.com',
  'depot.auction',
  'hibid.com',
  'shopgoodwill.com',
  'estatesales.net',
  'proxibid.com',
  'mac.bid',
  'liveauctioneers.com',
  'auctionzip.com',
  'govdeals.com',
  'publicsurplus.com',
  'gsaauctions.gov',
  'allsurplus.com',
  'govplanet.com',
  'ironplanet.com',
  'rbauction.com',
  'auctiontime.com',
  'equipmentfacts.com',
  'purplewave.com',
  'bidspotter.com',
  'directliquidation.com',
  'bstock.com',
  'pristineauction.com',
  'auctionninja.com',
];

export const DISALLOWED_SITE_MESSAGE = (
  'This website is not in the list of supported auction sites. ' +
  'The scanner can only analyze pages from approved auction / ' +
  'liquidation marketplaces.'
);
export const MAX_CLIENT_PAGE_HTML_BYTES = 4 * 1024 * 1024;
export const DEFAULT_SCAN_DELAY_MS = 0;
export const MAX_SCAN_DELAY_MS = 15000;

export const isAllowedAuctionUrl = (url) => {
  if (typeof url !== 'string' || !url) return false;
  let parsed;
  try {
    parsed = new URL(url);
  } catch (_err) {
    return false;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return false;
  }
  const host = (parsed.hostname || '').toLowerCase().replace(/^\.+|\.+$/g, '');
  if (!host) return false;
  return ALLOWED_AUCTION_DOMAINS.some(
    (domain) => host === domain || host.endsWith('.' + domain),
  );
};

export const clampScanDelayMs = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return DEFAULT_SCAN_DELAY_MS;
  return Math.max(0, Math.min(MAX_SCAN_DELAY_MS, Math.round(num)));
};

export const dedupeImageUrls = (urls) => {
  if (!Array.isArray(urls)) return [];
  return Array.from(
    new Set(
      urls
        .map((value) => String(value || '').trim())
        .filter((value) => value.startsWith('http://') || value.startsWith('https://'))
    )
  );
};

export const tryFetchPageHtmlForScan = async (url) => {
  if (!url) return '';
  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      redirect: 'follow',
      headers: {
        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
      },
    });
    if (!response.ok) return '';
    const contentType = String(response.headers.get('content-type') || '').toLowerCase();
    if (contentType && !contentType.includes('html') && !contentType.includes('xml')) {
      return '';
    }
    let html = await response.text();
    if (html.length > MAX_CLIENT_PAGE_HTML_BYTES) {
      html = html.slice(0, MAX_CLIENT_PAGE_HTML_BYTES);
    }
    return html;
  } catch (_error) {
    return '';
  }
};
